import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

function AdminLayout() {
  return (
    <div className="page admin-hub-page">
      <header className="page-header">
        <span className="page-eyebrow">Admin</span>
        <h1>Admin workspace</h1>
        <p className="page-subtitle">Use this area for operational checks and account management.</p>
      </header>

      <section className="panel admin-panel-surface">
        <div className="admin-nav-grid">
          <NavLink to="/admin" end className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Overview
          </NavLink>
          <NavLink to="/admin/monetization" className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Monetization
          </NavLink>
          <NavLink to="/admin/users" className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Users
          </NavLink>
          <NavLink to="/admin/payments" className={({ isActive }) => `btn ${isActive ? 'btn-primary' : 'btn-outline-secondary'}`}>
            Payments
          </NavLink>
          <div className="admin-nav-note text-muted small">Server-side admin gating is enforced for all endpoints.</div>
        </div>
      </section>

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
